import { render, staticRenderFns } from "./CheckboxConfigComponent.vue?vue&type=template&id=2ce08914&scoped=true&"
import script from "./CheckboxConfigComponent.vue?vue&type=script&lang=js&"
export * from "./CheckboxConfigComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce08914",
  null
  
)

export default component.exports